import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';
import util from '../util';
import messageFactory from '../models/messageModel';
import * as messageActions from '../messageActions';import { Popup, sortableComponent } from './sharedComponents';
import { getCollection, getModel, ModelCollection } from '../store';

const MessageContextMenu = ({ deleteAction }) => {
	const onDeleteClicked = () => {
		deleteAction();
	};

	return	(<div className="content scrollable">
		<ul className="menu">
			<li><a className="button icon iconLabel removeItem delete" onClick={ onDeleteClicked }><span>Delete</span></a></li>
		</ul>
	</div>);
};

class AddMessageTable extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.updateModel = this.updateModel.bind(this);
	}

	updateModel (e) {
		const { message } = this.props;

		message.content = (e.type === 'blur') ? valueFilters.trim(e.target.value) : e.target.value;

		this.forceUpdate();
	}

	handleButtonClick (e) {
		const { message } = this.props;

		e.preventDefault();

		const newVal = valueFilters.trim(message.content);

		if (_.isEmpty(newVal)) {
			return;
		}

		this.props.addMessageHandler();
	}

	render () {
		const { message, messageLabel = 'Message' } = this.props;

		return (
			<table className="compact notes" cellPadding="0" cellSpacing="0">
				<tbody>
					<tr>
						<td />
						<td className="note"><textarea placeholder={ `Add ${messageLabel}` } onChange={ this.updateModel } onBlur={ this.updateModel } value={ message.content || '' } /></td>
						<td className="action"><button className="icon iconOnly addItem" onClick={this.handleButtonClick} ><span /></button></td>
						<td />
					</tr>
				</tbody>
			</table>
		);
	}
}

const MessageTable = sortableComponent(class MessageTableInner extends React.Component<any,any> {
	handleClick (k, e) {
		e.preventDefault();
		this.props.updateSort(k);
	}

	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}

	render () {
		const { list, deleteMessage, messageLabel = 'Message' } = this.props;
		const rows = [];

		list.forEach((message) => {
			rows.push(<MessageTableRow message={message} key={message.key} deleteMessage={ deleteMessage } />);
		});

		return (
			<table className="sortable" cellPadding="0" cellSpacing="0">
				<thead>
					<tr>
						<td />
						<td className={this.getClassName('dateCreated')} onClick={this.handleClick.bind(this, 'dateCreated')}>Date</td>
						<td className={this.getClassName('content')} onClick={this.handleClick.bind(this, 'content')}>{ messageLabel }</td>
						<td className={this.getClassName('addedBy')} onClick={this.handleClick.bind(this, 'addedBy')}>Added By</td>
						<td />
						<td />
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
			</table>
		);
	}
});

class MessageTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.deleteMessage = this.deleteMessage.bind(this);
		this.handleContextClick = this.handleContextClick.bind(this);
	}

	deleteMessage () {
		this.props.deleteMessage(this.props.message.key);
		actions.popModal();
	}

	handleContextClick (e) {
		const popup = <Popup target={e.target}><MessageContextMenu deleteAction={ this.deleteMessage } /></Popup>;

		actions.pushModal({ component: popup });
	}

	render () {
		const { message } = this.props;

		return (
			<tr className="added">
				<td />
				<td className="date"><strong>{util.dateHelper.formatDate(message.dateCreated, { userFriendly: true })}</strong></td>
				<td className="note">{message.content}</td>
				<td className="addedBy">{message.addedBy}</td>
				<td className="action"><button className="icon iconOnly contextMenu" onClick={this.handleContextClick}><span /></button></td>
				<td />
			</tr>
		);
	}
}

export default class MessageChannel extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(this.props);

		this.deleteMessage = this.deleteMessage.bind(this);
	}

	componentDidMount () {
		const { channelKey } = this.props;

		messageActions.fetchMessages({ channel: channelKey });
		messageActions.watchChannel({ channel: channelKey });
	}

	componentWillUnmount () {
		const { channelKey } = this.props;

		messageActions.unwatchChannel({ channel: channelKey });
	}

	UNSAFE_componentWillReceiveProps (nextProps) {
		this.setState(this.getStateFromProps(nextProps));
	}

	getStateFromProps (props) {
		const state = _.assign({}, this.state);

		if (props.allowNewMessages && !state.pendingMessage) {
			state.pendingMessage = this.createPendingMessage(props);
		}

		return state;
	}

	createPendingMessage (props) {
		const { channelKey } = props;

		return messageFactory({ messageChannelKey: channelKey });
	}

	addMessageHandler (messageKey) {
		if (messageKey === this.state.pendingMessage.key) {
			messageActions.saveMessage({ message: this.state.pendingMessage });

			setTimeout(() => { this.setState({ pendingMessage: this.createPendingMessage(this.props) }); }, 0);
		}
	}

	deleteMessage (messageKey) {
		const { store } = componentServices;

		messageActions.deleteMessage({ message: getModel({ store, collection: ModelCollection.messages, key: messageKey }) });
	}

	render () {
		const { store } = componentServices;
		const { allowNewMessages, channelKey, className, ...childProps } = this.props;
		const messages = getCollection({ store, collection: ModelCollection.messages });
		const employees = getCollection({ store, collection: ModelCollection.employees });
		const list = [];

		messages.filter(m => m.messageChannelKey === channelKey).forEach(message => {
			const employee = employees.find(e => {
				return e.user.key === message.createdById;
			});

			list.push(_.assign({ addedBy: (employee ? employee.fullName : 'Unknown') }, message.toDocument()));
		});

		return (
			<div className={className}>
				{ allowNewMessages ? <AddMessageTable key={this.state.pendingMessage.key} message={this.state.pendingMessage} addMessageHandler={this.addMessageHandler.bind(this, this.state.pendingMessage.key)} { ...childProps } /> : null }
				<MessageTable list={ list } initialSortKey="dateCreated" deleteMessage={ this.deleteMessage } { ...childProps } />
			</div>
		);
	}
}
